import goride from "./goride.svg"
import gocar from "./gocar.svg"
import gobluebird from "./gobluebird.svg"
import gosend from "./gosend.svg"
import gopay from "./gopay.svg"
import gotagihan from "./gotagihan.svg"
import gopaylater from "./gopaylater.svg"
import gosure from "./gosure.svg"
import gofood from "./gofood.svg"
import gofood_solid from "./gofood_solid.svg"
import gomed from "./gomed.svg"
import gomed_solid from "./gomed_solid.svg"
import gomart from "./gomart.svg"
import gomart_solid from "./gomart_solid.svg"
import goshop from "./goshop.svg"
import goshop_solid from "./goshop_solid.svg"
import gobiz from "./gobiz.svg"
import gobiz_solid from "./gobiz_solid.svg"
import midtrans from "./midtrans.svg"
import midtrans_solid from "./midtrans_solid.svg"
import moka from "./moka.svg"
import moka_solid from "./moka_solid.svg"
import gostore from "./gostore.svg"
import selly from "./selly.svg"
import selly_solid from "./selly_solid.svg"
import gobox from "./gobox.svg"

const Image = {
    goride : goride,
    gobox: gobox,
    gocar : gocar,
    gobluebird: gobluebird,
    gosend: gosend,
    gopay: gopay,
    gotagihan: gotagihan,
    gopaylater: gopaylater,
    gosure: gosure,
    gofood: gofood,
    gofood_solid: gofood_solid,
    gomed: gomed,
    gomed_solid: gomed_solid,
    gomart: gomart,
    gomart_solid: gomart_solid,
    goshop: goshop,
    goshop_solid: goshop_solid,
    gobiz: gobiz,
    gobiz_solid: gobiz_solid,
    midtrans: midtrans,
    midtrans_solid: midtrans_solid,
    moka: moka,
    moka_solid: moka_solid,
    gostore: gostore,
    selly: selly,
    selly_solid: selly_solid,
}

export default Image;